<template>
  <div class="input-group input-group-seamless">
    <div class="input-group-prepend">
      <div class="input-group-text">
        <i class="fas fa-search"/>
      </div>
    </div>
    <input
      class="navbar-search form-control"
      type="text"
      :placeholder="placeholder"
      :id="id"
      aria-label="Search"
      v-model="search"
      size="md"
      @change="callChange"
      @keyup="callKeyUp"
    />
    <div class="input-group-append" v-if="search">
      <div class="input-group-text">
        <i
          v-b-tooltip.hover="{
            variant: 'dark',
            delay: { show: 500, hide: 50 },
            title: 'Limpar',
          }"
          class="fas fa-times custom-clear"
          @click="clear"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: 'Procurar por algo...',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    search: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
  },
  mounted() {
    this.search = this.model;
  },
  methods: {
    callChange(e) {
      this.$emit('change', e.target.value);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    clear() {
      this.search = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.input-group.input-group-seamless > .form-control {
  border-radius: 0.25rem;
}
.custom-clear {
  font-size: small;
  cursor: pointer;
}
</style>
